import {
  Bell,
  Calculator,
  Calendar,
  CircleQuestionMark,
  FileEdit,
  FileText,
  Globe,
  MessageSquare,
  Phone,
  Search,
  XCircle,
} from 'lucide-react';

import MailReplyIcon from '@/components/icons/MailReply';
import type { ActionType } from '@/types/actions';

type Props = {
  type: ActionType;
};

export default function ActionIcon({ type }: Props) {
  switch (type) {
    case 'UPDATE_POLICY':
    case 'RECALCULATE_POLICY':
      return <FileEdit className="text-primary-500 size-4 shrink-0" />;
    case 'SCHEDULE_MEETING':
      return <Calendar className="text-primary-500 size-4 shrink-0" />;
    case 'REPLY_TO_CLIENT':
      return <MailReplyIcon />;
    case 'SET_REMINDER':
      return <Bell className="text-primary-500 size-4 shrink-0" />;
    case 'RETRIEVE_INFO':
    case 'RUN_POLICY_TERMS_CHECK':
      return <Search className="text-primary-500 size-4 shrink-0" />;
    case 'TERMINATE_POLICY':
      return <XCircle className="text-primary-500 size-4 shrink-0" />;
    case 'CALCULATE_QUOTE':
      return <Calculator className="text-primary-500 size-4 shrink-0" />;
    case 'REVIEW_FORM':
    case 'SEND_RISK_ANALYSIS':
    case 'SEND_QUICKSCAN':
      return <FileText className="text-primary-500 size-4 shrink-0" />;
    case 'MANUAL_TASK':
      return <MessageSquare className="text-primary-500 size-4 shrink-0" />;
    case 'NAVIGATE_LINK':
      return <Globe className="text-primary-500 size-4 shrink-0" />;
    case 'CALL_CUSTOMER':
      return <Phone className="text-primary-500 size-4 shrink-0" />;
    default:
      return (
        <CircleQuestionMark className="text-primary-500 size-4 shrink-0" />
      );
  }
}
